import AntTable from 'antd-core/es/table';
import styled, { css } from 'styled-components';

const Root = styled(AntTable).attrs({
    $sizes: {
        large: css `
      &.tend-ui-table-wrapper .tend-ui-table-cell,
      &.tend-ui-table-wrapper .tend-ui-table-thead > tr > th,
      &.tend-ui-table-wrapper .tend-ui-table-tbody > tr > th,
      &.tend-ui-table-wrapper .tend-ui-table-tbody > tr > td,
      &.tend-ui-table-wrapper tfoot > tr > th,
      &.tend-ui-table-wrapper tfoot > tr > td {
        padding: 20px 12px;
      }
    `,
        medium: css ``,
        small: css ``,
    },
}) `
  &.tend-ui-table-wrapper {
    /* Removing header mini-border */
    .tend-ui-table-thead
      > tr
      > th:not(:last-child):not(.tend-ui-table-selection-column):not(
        .tend-ui-table-row-expand-icon-cell
      ):not([colspan])::before,
    .tend-ui-table-thead
      > tr
      > td:not(:last-child):not(.tend-ui-table-selection-column):not(
        .tend-ui-table-row-expand-icon-cell
      ):not([colspan])::before {
      content: none;
    }

    /* FIXME: Move to features/Table only component */
    /* Header cells hovering */
    /* .tend-ui-table-thead > tr > th,
    .tend-ui-table-thead > tr > td {
      transition: background-color 0.3s;
      &:hover {
        background-color: ${props => props.$theme.colors.gray50};
      }
    } */
    .tend-ui-table-row-expand-icon {
      border-radius: 4px;
      border-color: ${props => props.$theme.colors.gray200};
    }
    .tend-ui-table-column-title {
      flex: 0;
    }
    .tend-ui-table-column-sorters,
    .tend-ui-table-filter-column {
      justify-content: flex-start;
      gap: 4px;
      .anticon {
        font-size: 16px;
      }
    }
    .tend-ui-table-filter-trigger {
      margin-inline: 0px;
    }
    ${props => props.$pointer &&
    css `
        .tend-ui-table-row {
          cursor: pointer;
        }
      `};
  }
  ${props => props.$sizes[props.$size]}
`;

export { Root };
//# sourceMappingURL=styled.js.map
